export const ACTIVE_USER_FILTER_ACTIVE = 'active';
export const ACTIVE_USER_FILTER_ARCHIVED = 'archived';
export const ACTIVE_USER_FILTER_BOTH = 'both';

export const ACTIVE_USER_FILTER_SET_ARCHIVED = 0;
export const ACTIVE_USER_FILTER_SET_ACTIVE = 1;

export const activeUserFilterSetToMode = (activeSet) => {
  if (activeSet?.size === 2) return ACTIVE_USER_FILTER_BOTH;
  if (activeSet?.has(ACTIVE_USER_FILTER_SET_ARCHIVED) && activeSet.size === 1) {
    return ACTIVE_USER_FILTER_ARCHIVED;
  }
  return ACTIVE_USER_FILTER_ACTIVE;
};

export const activeUserFilterModeToSet = (mode) => {
  if (mode === ACTIVE_USER_FILTER_BOTH) {
    return new Set([ACTIVE_USER_FILTER_SET_ARCHIVED, ACTIVE_USER_FILTER_SET_ACTIVE]);
  }
  if (mode === ACTIVE_USER_FILTER_ARCHIVED) return new Set([ACTIVE_USER_FILTER_SET_ARCHIVED]);
  return new Set([ACTIVE_USER_FILTER_SET_ACTIVE]);
};

export const isDefaultActiveUserFilter = (activeSet) => (
  activeSet?.size === 1 && activeSet.has(ACTIVE_USER_FILTER_SET_ACTIVE)
);
